document.addEventListener("DOMContentLoaded", function () {
  // Count and show how many filters are applied
    const container = document.querySelector('.c-filters__refined-filters');
    const clearButton = document.querySelector('#resources-clear-all');

    if (!container || !clearButton) return;

    const checkboxes = container.querySelectorAll('input[type="checkbox"]');

    function updateClearButtonLabel() {
        const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length;
        if (checkedCount > 0) {
            clearButton.textContent = `Clear all (${checkedCount})`;
        } else {
            clearButton.textContent = 'Clear all';
        }
    }

    checkboxes.forEach(cb => {
        cb.addEventListener('change', updateClearButtonLabel);
    });

    updateClearButtonLabel();

    // Toggle filters on mobile
    const filterToggle = document.querySelector('#c-filter-toggle');
    const filterText   = document.querySelector('#c-filter-toggle__text');
    let stateFilterActive = false;

    if (filterToggle) {
        filterToggle.addEventListener("click", function () {
            toggleFilters(!stateFilterActive);
        });
    }

    function setAriaExpanded(){
        if (window.innerWidth >= BP_DESKTOP || stateFilterActive) {
            filterToggle.setAttribute('aria-expanded', 'true');
        } else {
            filterToggle.setAttribute('aria-expanded', 'false');
        }
    }

    const toggleFilters = function(value) {
        stateFilterActive = value;

        if(stateFilterActive){
            document.documentElement.classList.add('state--filters-active');
            if (filterText) filterText.textContent = "Hide Filter";
        } else {
            document.documentElement.classList.remove('state--filters-active');
            if (filterText) filterText.textContent = "Show Filter";
        }

        setAriaExpanded();
    };
});